<div class="work-application-container">
  <h1 class="page-title">施工申請單管理</h1>

    <!-- 表單資料顯示區塊 -->
  <div class="panel showlist-panel mt-4">
    <div class="panel-content">
      <app-showlist
        [formName]="'施工申請單'"
        [formId]="workApplicationFormId"
       >
      </app-showlist>
    </div>
  </div>

  </div>
